<div class="flex flex-col">
  <mat-card
    appearance="outlined"
    class="thumbnail-wrapper flex flex-col justify-center items-center"
  >
    @if (thumbnailLoading) {
    <mat-spinner data-pgr-id="docset-thumbnail-spinner"> </mat-spinner>
    } @if (thumbnailImage && thumbnailLoading === false) {
    <img
      class="thumbnail-image"
      [src]="thumbnailImage"
      data-pgr-id="docset-thumbnail-image"
      alt="Uploaded document thumbnail"
      tabindex="0"
    />
    } @if (thumbnailIcon && thumbnailLoading === false) {
    <mat-icon
      class="thumbnail-icon"
      data-pgr-id="docset-thumbnail-icon"
      aria-label="doc set thumbnail icon"
      aria-hidden="false"
      tabindex="0"
    >
      {{ thumbnailIcon }}
    </mat-icon>
    }
  </mat-card>
</div>
